const brandInfo = [
  {
    path: "/brandInfo",
    name: "brandInfo",
    component: () =>
      import(/* webpackChunkName: "brandInfo" */ "@/views/brandInfo/index"),
    meta: {
      name: "专利交易详情",
      breadCrumbName: "专利详情"
    }
  }
];

export default brandInfo;
